import logoUrl from './logo.png';

/* The public hb-enterprise-logo.jpg asset renders as a black square in Chrome
   print preview on some devices. Install this wrapper BEFORE the ledger branding
   wrapper: ledgerPrintBrandingExact decorates the srcdoc first, then calls this
   setter, which swaps the public JPG URL for Vite's bundled logo asset.

   Also normalize the old Islampur fallback phone number that was still hardcoded
   in the shared print header. The branch master already stores the correct number
   (9832005679); this protects any print path that builds a header without a branch
   object and would otherwise fall back to 9083391017. */
const proto = window.HTMLIFrameElement?.prototype;
const desc = proto && Object.getOwnPropertyDescriptor(proto, 'srcdoc');
if (proto && desc?.get && desc?.set && !proto.__hbLogoAssetFix) {
  Object.defineProperty(proto, 'srcdoc', {
    configurable: desc.configurable,
    enumerable: desc.enumerable,
    get: desc.get,
    set(value) {
      let next = value;
      if (typeof next === 'string') {
        next = next
          .replaceAll('/hb-enterprise-logo.jpg', logoUrl)
          .replaceAll('src="/hb-enterprise-logo.jpg"', `src="${logoUrl}"`)
          .replaceAll('9083391017', '9832005679');
      }
      return desc.set.call(this, next);
    },
  });
  Object.defineProperty(proto, '__hbLogoAssetFix', { value: true });
}
